var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar',{attrs:{"flat":"","color":_vm.themeColor}},[_c('v-img',{attrs:{"id":"survey_logo","max-width":250,"max-height":50,"src":_vm.headerLogo,"contain":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }